import config from 'config';
import { http_client } from './api';
import { showSessionExpiredOverlay } from '../utils/sessionExpiredHandler';

const register = async (username, email, password) => {
  return http_client
    .post(config.apiUrl + 'register', {
      username,
      email,
      password
    })
    .then((response) => {
      localStorage.setItem('token', response.data.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.data.user));
      localStorage.setItem('permission', JSON.stringify(response.data.data.permission));
      window.location.replace('/');
      return response.data;
    });
};

const login = async (email, password, remember = false) => {
  return http_client.get(config.baseApiUrl + 'sanctum/csrf-cookie').then(() => {
    return http_client
      .post('login', {
        email,
        password,
        remember
      })
      .then((response) => {
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        localStorage.setItem('permission', JSON.stringify(response.data.data.permission));
        window.location.replace('/');
        return response.data;
      });
  });
};

const setFcmToken = async (data) => {
  return http_client.post(config.baseApiUrl + 'fcmtoken', data).then((response) => {
    return response.data;
  });
};

const logout = async () => {
  try {
    await http_client.post('logout');
  } catch (error) {
    // Token mungkin sudah expired, tetap lanjut bersihkan localStorage
    console.warn('Logout API call failed:', error?.message);
  } finally {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('permission');
    localStorage.removeItem('filterHarga');
    window.location.replace('/login');
  }
};
const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('permission');
  localStorage.removeItem('filterHarga');
  showSessionExpiredOverlay();
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user') ?? '{}');
};

const getPermission = () => {
  return JSON.parse(localStorage.getItem('permisson') ?? '[]');
};

const AuthService = {
  register,
  login,
  setFcmToken,
  logout,
  clearAuth,
  getCurrentUser,
  getPermission
};

export default AuthService;
